<template>
  <svg :class="svgClass" aria-hidden="true">
    <use :xlink:href="`${require('@/assets/icons/svg/'+iconClass+'.svg')}#${iconClass}`" :fill="iconColor" />
  </svg>
</template>

<script>
export default {
  name: 'IconSvg',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String, // Assuming color is provided as a string
      default: 'currentColor' // 如果未提供，则默认为 currentColor
    }
  },
 
  computed: {
    svgClass() {
      if (this.className) {
        return this.iconClass + ' svg-icon ' + this.className;
      } else {
        return this.iconClass + ' svg-icon';
      }
    },
  }
}
</script>

<style scoped>
.svg-icon {
  width: 24px;
  height: 24px;
  fill: currentColor;
  font-size: 16px;
}
</style>